<div class="tournaments-page">
  <header class="page-header"><h1>My Tournaments</h1></header>

  <ng-container *ngIf="!loading">
    <div class="empty-state" *ngIf="isEmpty" data-testid="empty-state">
      <div class="empty-state-icon"><lucide-icon name="trophy" [size]="32"></lucide-icon></div>
      <h2>You haven't joined any tournaments yet</h2>
      <p>Browse tournaments and register to see them here.</p>
    </div>

    <ng-container *ngFor="let group of [
      { title: 'Upcoming', rows: upcoming },
      { title: 'Active', rows: active },
      { title: 'Completed', rows: completed }
    ]">
      <section class="my-group" *ngIf="group.rows.length > 0" [attr.data-testid]="'group-' + group.title">
        <h2 class="group-title">{{ group.title }}</h2>
        <ul class="tournament-grid">
          <li
            *ngFor="let r of group.rows"
            class="tournament-card"
            data-testid="my-tournament-card"
            (click)="goToDetail(r.tournament.id)">
            <div class="tournament-card-header">
              <h3>{{ r.tournament.name }}</h3>
              <span class="badge">{{ r.tournament.registered_teams_count }} / {{ r.tournament.max_teams }}</span>
            </div>
            <p class="tournament-card-meta">
              {{ r.tournament.club_name }} · {{ r.tournament.start_date | date:'mediumDate' }}
            </p>
          </li>
        </ul>
      </section>
    </ng-container>
  </ng-container>
</div>
